import * as Yup from 'yup'

export const emailTemplateSchema = Yup.object().shape({
  label: Yup.string().required('Label Required!'),
  type: Yup.string().required('Type Required!'),
  tenantId: Yup.string().required('Portal Required!'),
  licenseId: Yup.string().when('$isEdit', {
    is: false, // Only required when not in edit mode
    then: Yup.string().required('License Required!'),
    otherwise: Yup.string().nullable() // Allow null or undefined in edit mode
  })
})
